import React from "react"
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CCOContainer from "../../fundamentals/CCOContainer";
import VolunteerActivismOutlinedIcon from "@mui/icons-material/VolunteerActivismOutlined";
import CCOHeadline from "../../fundamentals/CCOHeadline";
import CCOSvg from "../../fundamentals/CCOSvg";
import CCOLink from "../../fundamentals/CCOLink";
import CCOComponentWrapper from "../../fundamentals/CCOComponentWrapper";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {SosTeaserType} from "../../types";
import {metaDataProperty} from "../../preview/previewMetaData";
import {usePreviewContext} from "../../../context/PreviewContext";


export interface Props {
    sosTeaser: SosTeaserType
}

function C023NewsletterTeaser(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    return (
        <CCOComponentWrapper background={"#ECEEF9"}>
            <CCOContainer background={"#ECEEF9"} id={props.sosTeaser.id}>
                {props.sosTeaser.globalFactsSettings?.teaser_icon ?
                    <CCOSvg uri={props.sosTeaser.globalFactsSettings?.teaser_icon} circled={true}
                            size={30}/>
                    : <VolunteerActivismOutlinedIcon fontSize={'large'}/>}
                <CCOHeadline headline={props.sosTeaser.teaserTitle} type={"h3"} metadataId={props.sosTeaser.id}
                             propertyName='properties.teaserTitle'
                             strong={true} margin={{t: 5}}/>
                <Box sx={{
                    textAlign: 'center',
                    paddingX: {xs: 2, md: 5, lg: 6},
                }}>
                    {props.sosTeaser.headline ?
                        <Typography
                            align={'center'}
                            {...metaDataProperty(isPreview,
                                'properties.headline',
                                props.sosTeaser.id)}
                            variant="body1"
                            gutterBottom
                            sx={{
                                marginY: 4
                            }}>
                            {props.sosTeaser.headline}
                        </Typography>
                        : null}
                    <CCOLink target={props.sosTeaser}
                             name={props.sosTeaser.teaserCallToActionSettings?.callToActionCustomText ??
                                 ''}
                             icon={<ArrowForwardIcon sx={{
                                 height: '0.75em',
                                 width: '0.75em',
                                 mb: '-3px',
                                 mr: '8px'
                             }}/>}
                             noWrap={true}
                             openInTab={props.sosTeaser.teaserTarget?.openInNewTab}
                    />
                </Box>
            </CCOContainer>
        </CCOComponentWrapper>
    );
}

export default C023NewsletterTeaser;